"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["AnonymousStudentServiceReady"] = "anonymous-student-service-ready";
    EventType["AnonymousStudentProfileUpdated"] = "anonymous-student-profile-updated";
    EventType["AnonymousStudentProfileSynced"] = "anonymous-student-profile-synced";
    EventType["AnonymousStudentStateChanged"] = "anonymous-student-state-changed";
})(EventType = exports.EventType || (exports.EventType = {}));
